/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.activities', {
            parent: 'board',
            url: '/board/{select}/activities?page&sort&search&query',
            data: {
                authorities: ['ROLE_BOARD'],
                pageTitle: 'askApp.activities.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/board/activities/activities.html',
                    controller: 'ActivitiesBoardController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'activitiesDate,desc',
                    squash: true
                },
                query: {
                    value: 'useable',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        select: $stateParams.select,
                        query: $stateParams.query
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activities');
                    $translatePartialLoader.addPart('enumCategoryActivity');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MemberManagement', function($stateParams, MemberManagement) {
                    if($stateParams.select) {
                        return MemberManagement.get({id : $stateParams.select}).$promise;
                    }
                    return null;
                }]
            }
        })
        .state('board.activities.new', {
            parent: 'board.activities',
            url: '/new/{user}',
            data: {
                authorities: ['ROLE_BOARD']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/activities/activities-dialog.html',
                    controller: 'ActivitiesBoardDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['MemberManagement', function(MemberManagement) {
                            return {
                                activitiesDate: null,
                                validFrom: null,
                                category: null,
                                id: null
                            };
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.activities', null, { reload: 'board.activities' });
                }, function() {
                    $state.go('board.activities');
                });
            }]
        })
         .state('board.activities.edit', {
            parent: 'board.activities',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/activities/activities-dialog.html',
                    controller: 'ActivitiesBoardDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['Activities', function(Activities) {
                            return Activities.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.activities', null, { reload: 'board.activities' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.activities.delete', {
            parent: 'board.activities',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/activities/activities-delete-dialog.html',
                    controller: 'ActivitiesBoardDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Activities', function(Activities) {
                            return Activities.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.activities', null, { reload: 'board.activities' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
